import { Breadcrumb } from '@ui/components/navigation'
import { ExtraParams } from '@ui/interfaces/navigation'
import { Profile } from '@ui/pages/profile'
import { RouteNamesEnum } from '@ui/router/routes'

export const ProfileRoutes = () => {
  return {
    name: RouteNamesEnum.PROFILE,
    path: '/profile',
    element: <Profile />,
    handle: {
      crumb: (data: ExtraParams) => <Breadcrumb crumbStyle={data.crumbStyle} to="/profile" label="Profile" />,
    },
  }
}
